import React from 'react'
import './loading.css'
const Loading = () => {
  return (
    <h4 style={{color:"red"}}><div class="loader"></div></h4>
  )
}

export default Loading